import { render, staticRenderFns } from "./download_product.vue?vue&type=template&id=b53e5132&"
import script from "./download_product.vue?vue&type=script&lang=js&"
export * from "./download_product.vue?vue&type=script&lang=js&"
import style0 from "./download_product.vue?vue&type=style&index=0&id=b53e5132&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports